/* eslint-disable max-len */
import React from 'react';
function ViewAgendaOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M19 5v4H4V5h15m0 10v4H4v-4h15m1-12H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm0 10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1z" })));
}
export default ViewAgendaOutlined;
